import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { Subject, throwError } from 'rxjs';
import { catchError, map, publishReplay, refCount } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserPaidService {
  error = new Subject<string>();
  slug = '/user_paids';
  resourceName = 'user_paids';
  allPaids?: any;
  paidsBetween?: any;
  
  constructor(private http: HttpClient) {}

  fetchAll(): any {
    if (!this.allPaids) {
      this.allPaids = this.http
        .get<any>(environment.apiUrl + this.slug, {
          responseType: 'json',
        })
        .pipe(
          map((responseData) => {
            const returnArray: any[] = [];
            responseData['_embedded'][this.resourceName].forEach(
              (item: any) => {
                returnArray.push(item);
              }
            );
            return returnArray;
          }),
          catchError((errorRes) => {
            return throwError(errorRes);
          }),
          publishReplay(1),
          refCount()
        );
    }

    return this.allPaids;
  }

  clearCache() {
    this.allPaids = null;
    this.paidsBetween = null;
  }

  
  fetch(id: number) {
    return this.http
      .get<any>(environment.apiUrl + this.slug + '/' + id, {
        responseType: 'json',
      })
      .pipe(
        map((responseData) => {
        
          return responseData;
        }),
        catchError((errorRes) => {
          return throwError(errorRes);
        })
      );
  }

  create(
    paid: string,
    date_recorded: string,
  ) {
    this.clearCache();
    const payload = {
      date_recorded: moment(date_recorded).format('YYYY-MM-DD'),
      paid,
    };
    return this.http.post<any>(environment.apiUrl + this.slug, payload, {
      observe: 'response',
    });
  }

  update(
    id: number,
    paid: string,
    date_recorded: string,
  ) {
    this.clearCache();
    const payload = {
      date_recorded: moment(date_recorded).format('YYYY-MM-DD'),
      paid,
    };
    return this.http.patch<any>(
      environment.apiUrl + this.slug + '/' + id,
      payload,
      {
        observe: 'response',
      }
    );
  }

  delete(id: number) {
    this.clearCache();
    return this.http.delete<{ name: string }>(
      environment.apiUrl + this.slug + '/' + id
    );
  }



  getRag(paid) {
    let ragColour = '';
    if (+paid <=40) {
      ragColour = 'green';
    } else if (+paid>50) {
      ragColour = 'red';
    } else {
      ragColour = 'amber';
    }

    return ragColour;
  }

  getPaidforColor(colour: string) {
    let ragRange = '';
    if (colour == 'green') {
      ragRange = '≤40';
    } else if (colour == 'amber') {
      ragRange = '41-50';
    } else {
      ragRange = '>50';
    }

    return ragRange;
  }
}
